import type {IData} from "@/interfaces";

export const META: IData = {
    budgetTitles: {
        "2022-SoSe": "3.9.6.9 SS 2022",
        "2022-WiSe": "3.9.6.8 WS 2022/23",
        "2023-SoSe": "3.9.6.7 SS 2023",
        "2023-WiSe": "3.9.6.6 WS 2023/24",
        "2024-SoSe": "3.9.6.5 SS 2024",
        "2024-WiSe": "3.9.6.4 WS 2024/25",
        "2025-SoSe": "3.9.6.3 SS 2025",
        "2025-WiSe": "3.9.6.2 WS 2025/26",
        "2026-SoSe": "3.9.6.1 SS 2026",
    },
    afsgBudgetTitles: {
        "Agrarwissenschaften": "3.9.1.1 Agrarwissenschaften",
        "Anglistik-Amerikanistik-und-Keltologie": "3.9.1.2 Anglistik, Amerikanistik und Keltologie",
        "Archaeologie": "3.9.1.3 Archäologie",
        "Biologie": "3.9.1.4 Biologie",
        "Chemie": "3.9.1.5 Chemie",
        "ELW": "3.9.1.6 ELW",
        "Ethnologie-Altamerikanistik": "3.9.1.7 Ethnologie / Altamerikanistik",
        "Evangelische-Theologie": "3.9.1.8 Evangelische Theologie",
        "GeKoSka": "3.9.1.9 GeKoSka",
        "Geodaesie": "3.9.2.1 Geodäsie",
        "Geographie": "3.9.2.2 Geographie",
        "Geowissenschaften": "3.9.2.3 Geowissenschaften",
        "Geschichte": "3.9.3.4 Geschichte",
        "Informatik": "3.9.2.5 Informatik",
        "Interkulturelle-Kommunikation-und-Mehrsprachigkeitsforschung-IKM": "3.9.2.6 Interkulturelle Kommunikation und Mehrsprachigkeitsforschung (IKM)",
        "Jura": "3.9.2.7 Jura",
        "Katholische-Theologie": "3.9.2.8 Katholische Theologie",
        "Klassische-und-Romanische-Philologie": "3.9.2.9 Klassische und Romanische Philologie",
        "Kulturanthropologie": "3.9.3.1 Kulturanthropologie",
        "Kunstgeschichte": "3.9.3.2 Kunstgeschichte",
        "Lehramt": "3.9.3.3 Lehramt",
        "Mathematik": "3.9.3.4 Mathematik",
        "Medienwissenschaft": "3.9.3.5 Medienwissenschaft",
        "Medizin": "3.9.3.6 Medizin",
        "Meteorologie-und-Geophysik": "3.9.3.7 Meteorologie und Geophysik",
        "Molekulare-Biomedizin": "3.9.3.8 Molekulare Biomedizin",
        "Musikwissenschaften-Sound-Studies": "3.9.3.9 Musikwissenschaften/Sound Studies",
        "Neuroscience": "3.9.4.1 Neuroscience",
        "OrientAsia": "3.9.4.2 OrientAsia",
        "Pharmazie": "3.9.4.3 Pharmazie",
        "Philosophie": "3.9.4.4 Philosophie",
        "Physik-Astronomie": "3.9.4.5 Physik/Astronomie",
        "Politik-Soziologie": "3.9.4.6 Politik & Soziologie",
        "Psychologie": "3.9.4.7 Psychologie",
        "VWL": "3.9.4.8 VWL",
        "Zahnmedizin": "3.9.4.9 Zahnmedizin",
    },
    bfsgBudgetTitle: "3.9.7.1 BFSG (beantragbar)",
}
